// Colunas da planilha de colaboradores: o modelo de importação e o export usam os
// mesmos cabeçalhos, então o arquivo exportado pode ser reimportado.
export const EMPLOYEE_SHEET_COLUMNS = [
  { key: "name", label: "Nome", required: true },
  { key: "email", label: "E-mail", required: true },
  { key: "document", label: "CPF/CNPJ", required: true },
  { key: "phone", label: "WhatsApp" },
  { key: "job", label: "Cargo" },
  { key: "corporate_email", label: "E-mail corporativo" },
  { key: "erp_code", label: "Código ERP" },
];

const normalizeHeader = (header) =>
  header
    .toString()
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "");

// Cabeçalho normalizado -> chave interna. Inclui os nomes em inglês do modelo antigo.
const HEADER_ALIASES = {
  nome: "name",
  name: "name",
  "e-mail": "email",
  email: "email",
  "cpf/cnpj": "document",
  cpf: "document",
  cnpj: "document",
  documento: "document",
  document: "document",
  whatsapp: "phone",
  telefone: "phone",
  phone: "phone",
  cargo: "job",
  job: "job",
  "e-mail corporativo": "corporate_email",
  "email corporativo": "corporate_email",
  corporate_email: "corporate_email",
  "codigo erp": "erp_code",
  erp_code: "erp_code",
};

/** Converte uma linha lida da planilha para as chaves internas; colunas desconhecidas são descartadas. */
export function normalizeEmployeeSheetRow(row) {
  const normalized = {};
  Object.entries(row).forEach(([header, value]) => {
    const key = HEADER_ALIASES[normalizeHeader(header)];
    if (key && normalized[key] === undefined) {
      normalized[key] = value;
    }
  });
  return normalized;
}

export const employeeSheetLabel = (key) =>
  EMPLOYEE_SHEET_COLUMNS.find((c) => c.key === key)?.label || key;

export const linkStatusLabel = (status) =>
  status === "WAITING" ? "Aguardando primeiro acesso" : "Ativo";
